import DetailsSection from './DetailsSections';
import LibrarySection from './LibrarySection';
import PlatformSection from './PlatformSection';
export default class DgPage {
    static fromApi(response) {
        const page = new DgPage();
        if (response === null || response === void 0 ? void 0 : response.details_section)
            page.details_section = DetailsSection.fromPartial(response.details_section);
        if (response === null || response === void 0 ? void 0 : response.platform_section)
            page.platform_section = PlatformSection.fromPartial(response.platform_section);
        if (response === null || response === void 0 ? void 0 : response.library_section)
            page.library_section = LibrarySection.fromPartial(response.library_section);
        return page;
    }
}
